[
  {
    "code": "BS-AC",
    "name": "Acklins and Crooked Islands"
  },
  {
    "code": "BS-BY",
    "name": "Berry Islands"
  },
  {
    "code": "BS-BI",
    "name": "Bimini"
  },
  {
    "code": "BS-CI",
    "name": "Cat Island"
  },
  {
    "code": "BS-MH",
    "name": "Central Abaco, Hope Town and Green Turtle Cay"
  },
  {
    "code": "BS-FC",
    "name": "Central Andros"
  },
  {
    "code": "BS-GH",
    "name": "Central Eleuthera"
  },
  {
    "code": "BS-HR",
    "name": "East Grand Bahama"
  },
  {
    "code": "BS-EX",
    "name": "Exuma and Black Point"
  },
  {
    "code": "BS-FP",
    "name": "Freeport and West Grand Bahama"
  },
  {
    "code": "BS-IN",
    "name": "Inagua"
  },
  {
    "code": "BS-LI",
    "name": "Long Island"
  },
  {
    "code": "BS-MG",
    "name": "Mayaguana"
  },
  {
    "code": "BS-NP",
    "name": "New Providence"
  },
  {
    "code": "BS-GT",
    "name": "North Abaco and Grand Cay"
  },
  {
    "code": "BS-NS",
    "name": "North Andros"
  },
  {
    "code": "BS-HI",
    "name": "North Eleuthera, Harbour Island and Spanish Wells"
  },
  {
    "code": "BS-RI",
    "name": "Ragged Island"
  },
  {
    "code": "BS-SR",
    "name": "San Salvador and Rum Cay"
  },
  {
    "code": "BS-SP",
    "name": "South Abaco and Moore's Island"
  },
  {
    "code": "BS-KB",
    "name": "South Andros and Mangrove Cay"
  },
  {
    "code": "BS-RS",
    "name": "South Eleuthera"
  }
]